import routeName from '../constant';

const routes = [
    {
        path: 'auto-prem-Loan',
        name: routeName.AUTO_PREM_LOAN,
        component: () => import('@/views/aplCatl640and631/C4/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '自動墊繳意願變更', leaveAlert: true, code: 'C4', unableBack: true },
    }];

export default routes;
